import { addStream } from '../../epicStore'
import { merge, Observable } from 'rxjs'
import { pluck, map, tap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import * as actionTypes from '../../../constants/actionTypes'
import { setBookingStatus } from '../../../actions/docs/docsActions'
import { setLiveTime } from '../../../actions/gig/gigActions'
import { debug } from '@bt-react/libs/Logger'
import { ReduxAction } from '../../../reducers/reducerType'
import { docBookingListenersAdded, removeBookingDoc } from '../../../actions/docs/docsActions'

const addBackendEvents$ = (actions$, state) => actions$.pipe(
  ofType(actionTypes.SET_BOOKING_DOCUMENT),
  pluck('payload'),
  map((doc: any) =>
    new Observable(observer => {
      merge(
        doc.on('updated', ({ data: docEntry }) => {

          for (const [key, data] of Object.entries(docEntry)) {

            switch (key) {

              case 'status':
                if (data === 'LIVE') observer.next(setLiveTime(state.value.docs.bookingDoc.dateUpdated))

                return observer.next(setBookingStatus(data))
              default:
                break

            }

          }

        }),
        doc.on('removed', () => {

          debug(`Booking document has been removed`)
          observer.next(removeBookingDoc())
          observer.complete()

        })
      )
    })
  ),
  tap((stream$: Observable<ReduxAction>) => addStream(stream$)),
  map(() => docBookingListenersAdded())
)

export default addBackendEvents$
